module.exports = function getResource(label, vars = []) {
    let resources = {
        signIn: 'Ouvrir une session',
        sigInToSeeItems: 'Ouvrez une session pour voir les articles que vous pourriez avoir ajoutés précédemment.',
        seeSamplesRewardsPromotions: 'Voir les échantillons, les récompenses et les promotions dans le',
        basket: 'panier',
        dcTotal: 'Faites livrer ',
        basketTotal: 'Sous-total ',
        reserveTotal: 'Réservation et ramassage ',
        bopisTotal: 'Achat en ligne et ramassage ',
        checkout: 'Voir le panier et passer à la caisse',
        emptyBasket: 'Votre panier est vide.',
        itemsInBasket: `${vars[0]} article(s)${vars[1]} dans le panier`,
        itemsAddedToBasket: `${vars[0]} article(s)${vars[1]} ajouté(s) au panier`,
        itemCount: `${vars[0]} article(s)${vars[1]}`,
        or: 'ou',
        shopNewArrivals: 'Découvrir les nouveautés',
        viewAll: 'Tout afficher',
        freeShipping: 'Expédition gratuite',
        createAccount: 'Créer un compte',
        basketHeader: `Faites livrer (${vars[0]})`,
        reserveHeader: `Réservation et ramassage (${vars[0]})`,
        bopisHeader: `Achat en ligne et ramassage (${vars[0]})`,
        sameDayDelivery: 'Livraison le jour même',
        standardDelivery: 'Standard'
    };

    return resources[label];
};
